module.exports = __webpack_public_path__ + "static/media/economus.f2fdec39.jpg";